import { Barber } from '../types/barber.types';

export const generateBarberSlug = (barber: Barber): string => {
    let base = '';
    if (barber.nickname && barber.nickname.trim() !== '') {
        base = barber.nickname;
    } else if (barber.email) {
        base = barber.email.split('@')[0];
    } else {
        base = `${barber.firstName} ${barber.lastName}`;
    }
    
    return base
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "") // remove accents
        .toLowerCase()
        .replace(/\s+/g, '-') // spaces to hyphens
        .replace(/[^a-z0-9-]/g, '') // remove special chars
        .replace(/-+/g, '-') // remove multiple hyphens
        .replace(/^-|-$/g, ''); // trim hyphens
};
